<template>
    <div class="container">
        <h1>Configure Devices</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="List">
                <app-device-list :devices="list"></app-device-list>
            </b-tab-item>
            <b-tab-item label="Add Device">
                <app-add-device :afterAdd="handleAfterAdd"></app-add-device>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import DeviceList from '../components/configure/DeviceList';
    import BTabItem from "buefy/src/components/tabs/TabItem";
    import AddDevice from '../components/configure/AddDevice';

  export default {
    name: "screenconfiguredevices",
    components: {
      BTabItem,
      appDeviceList: DeviceList,
      appAddDevice: AddDevice
    },
    data() {
      return {
        activeTab: 0
      };
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('devices', ['devices']),
      list() {
        if (!this.devices) {
          return [];
        }

        return this.devices.map(item => {
          return {
            ...item,
            hftPlugged: item.plugged ? 'Yes' : 'No',
            hftParent: item.parent_id > 0 ? item.parent_device_name : ''
          }
        });
      }
    },
    methods: {
      handleAfterAdd() {
        this.activeTab = 0;
      }
    }
  }
</script>

<style scoped>
h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}
</style>